import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import Footer from './components/Footer';
import AccelPage from './pages/AccelPage';
import RBCSupportPage from './pages/RBCSupportPage';
import RiskFinancingPage from './pages/RiskFinancingPage';
import ContactPage from './pages/ContactPage';
import AccelTermsPage from './pages/AccelTermsPage';
import Clarity from '@microsoft/clarity';

const projectId = "qxv1y3jev7"

Clarity.init(projectId);

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          {/* Note: check ./staticwebapp.config.json for routing with hashrouter in Azure SWA*/}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/accel" element={<AccelPage />} />
            <Route path="/accel/terms" element={<AccelTermsPage />} />
            <Route path="/riskfinancing" element={<RiskFinancingPage/>} />
            <Route path="/rbc" element={<RBCSupportPage/>} />
            <Route path="contact" element={<ContactPage />} />
          </Routes>
          <Footer/>
        </main>
      </div>
    </Router>
  );
}

export default App;
